import React from "react";
import { Badge } from "@libs/zapi-ui/shadcn";
import { Timer } from "@phosphor-icons/react";

type TExecutionTimeBadgeProps = {
  executionTime: number | null;
  className?: string;
};

export function ExecutionTimeBadge({ executionTime, className }: TExecutionTimeBadgeProps) {
  if (!executionTime) {
    return (
      <Badge
        variant="secondary"
        className={`mr-2 inline-flex items-center gap-1 rounded-[12px] bg-zinc-100 text-zinc-700 ${className ?? ""}`}
      >
        <Timer size={14} className="text-zinc-700" />
        --
      </Badge>
    );
  }

  const seconds = executionTime / 1000;

  let bgColor = "bg-green-50";
  let textColor = "text-green-900";
  if (seconds > 20) {
    bgColor = "bg-red-50";
    textColor = "text-red-700";
  } else if (seconds > 10) {
    bgColor = "bg-yellow-100";
    textColor = "text-yellow-700";
  }

  return (
    <Badge
      variant="secondary"
      className={`mr-2 inline-flex items-center gap-1 rounded-[12px] ${bgColor} ${textColor} ${className ?? ""}`}
    >
      <Timer size={14} className={textColor} />
      {seconds.toFixed(2)}s
    </Badge>
  );
}
